import { getItemDictionary } from '@/api/dictionary/dictionary'

const user = {
    state: {
        userInfo: {},
        Token: '',
        dictionaryList: []
    },
    getters: {
        getDictionaryList (state) {
            return state.dictionaryList
        }
    },
    mutations: {
        setToken(state,info){
            state.Token = info
            // state.Token = 'info'
        },
        setUserInfo(state,info){
            state.userInfo = info
        },
        // 设置字典项列表数据
        setDictionaryList (state, list) {
            state.dictionaryList = list
        }
    },
    actions: {
        // 获取字典列表数据
        async fetchDictionaryList ({ commit }, params) {
            const res = await getItemDictionary(params)
            if (res.code === 200) {
                const records = res.data.records.map(item => ({
                    dictCode: item.dictCode,
                    status: item.status,
                    label: item.itemName,
                    value: item.itemValue,
                    sysDictItemId: item.id,
                    sysDictItemName: item.itemName
                }))
                // 同时过滤掉 status 为 0 (禁用) 的数据
                const recordsFilter = records.filter(item => item.status !== 0)
                commit('setDictionaryList', recordsFilter)
            }
        }
    }

}
export default user
